import { render, staticRenderFns } from "./ManageSpecialist.vue?vue&type=template&id=99d5bf9e&scoped=true"
import script from "./ManageSpecialist.vue?vue&type=script&lang=js"
export * from "./ManageSpecialist.vue?vue&type=script&lang=js"
import style0 from "./ManageSpecialist.vue?vue&type=style&index=0&id=99d5bf9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d5bf9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d5bf9e')) {
      api.createRecord('99d5bf9e', component.options)
    } else {
      api.reload('99d5bf9e', component.options)
    }
    module.hot.accept("./ManageSpecialist.vue?vue&type=template&id=99d5bf9e&scoped=true", function () {
      api.rerender('99d5bf9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/ManageSpecialist.vue"
export default component.exports